import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/config/api'
import { publicAxios } from '@/lib/axios'
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query'
import { AddressSuggestionsDto } from '@/types'

const getAddressSearch = (input: string, signal?: AbortSignal): Promise<AddressSuggestionsDto> =>
  publicAxios.get(`/search/address?query=${input}`, { signal })

type QueryFnType = typeof getAddressSearch

type UseGetAddressSearchOptions = {
  input: string
  config?: QueryConfig<QueryFnType>
}

export const useGetAddressSearch = ({ input, config }: UseGetAddressSearchOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [QUERY_KEYS.getAddressSearch, input],
    queryFn: ({ signal }) => getAddressSearch(input, signal),
  })
}
